import axios from "@/lib/axios"

export interface LMSCourse {
    id: number
    title: string
    slug: string
    description: string
    short_description: string
    thumbnail: string
    category: string
    price: string
    course_url: string
    enrollment_count: number
    duration_hours: number
    is_featured: boolean
}

export interface OpenEnrollmentResponse {
    success: boolean
    count: number
    courses: LMSCourse[]
}

export const lmsService = {
    getOpenEnrollment: async () => {
        const response = await axios.get<OpenEnrollmentResponse>("/lms/open-enrollment")
        return response.data
    }
}
